import {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import UserSearchInput from 'components/UserSearchInput';
import {useToggle} from 'hooks';
import SendModal from 'modals/SendModal';
import {getManager, getSelf} from 'selectors/state';
import {SFC, UserReadSerializer} from 'types';

import * as S from './Styles';

export interface SendCoinsSectionProps {
  onTransferSuccess?: () => void;
}

const SendCoinsSection: SFC<SendCoinsSectionProps> = ({className, onTransferSuccess}) => {
  const [recipient, setRecipient] = useState<UserReadSerializer | null>(null);
  const [sendModalIsOpen, toggleSendModal] = useToggle(false);
  const manager = useSelector(getManager);
  const self = useSelector(getSelf);
  const {activeWallet} = manager;

  const handleRecipientChange = useCallback((user: UserReadSerializer | null) => {
    setRecipient(user);
  }, []);

  const handleSendClick = () => {
    if (recipient) {
      toggleSendModal();
    }
  };

  const handleSendSuccess = useCallback(() => {
    if (onTransferSuccess) {
      onTransferSuccess();
    }
  }, [onTransferSuccess]);

  useEffect(() => {
    setRecipient(null);
  }, [activeWallet?.id]);

  if (!activeWallet || !self) return null;

  return (
    <>
      <S.Container className={className}>
        <S.Title>Send {activeWallet.currency.ticker}</S.Title>
        <S.SearchRow>
          <UserSearchInput
            errors={{}}
            label="Search for recipient"
            name="recipient"
            onChange={handleRecipientChange}
            touched={{}}
            value={recipient}
          />
          <S.SendButton disabled={!recipient} onClick={handleSendClick} text={`Send ${activeWallet.currency.ticker}`} />
        </S.SearchRow>
      </S.Container>
      {sendModalIsOpen && recipient && (
        <SendModal close={toggleSendModal} onSuccess={handleSendSuccess} recipient={recipient} />
      )}
    </>
  );
};

export default SendCoinsSection;
